import { Component, Inject } from '@angular/core';
import { NavMenuItems } from 'dm-src/app/modules/nav-menu/nav-menu-items';
import { environment } from '../../../environments/environment.prod';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css'],
})
export class NavMenuComponent {
    public menuItems: any[];

    appVersion = environment.appVersion;

    constructor(private translate: TranslateService) {
        this.translate.onLangChange.subscribe(() => this.updateMenuItemsVisibility());
    }

    private updateMenuItemsVisibility() {
        this.menuItems = NavMenuItems.filter(item => {
            if (item.children && item.children.length > 0) {
                item.children = item.children.filter(child => {
                    if (!child.onlyIfTranslated) return true;
                    const translated = this.translate.instant(child.label);
                    return !!translated && translated !== child.label;
                });

                if (item.children.length > 0) {
                    return true
                };

                if (!item.onlyIfTranslated) {
                    return true
                };

                const parentTranslated = this.translate.instant(item.label);

                return !!parentTranslated && parentTranslated !== item.label;
            }

            if (!item.onlyIfTranslated) {
                return true
            };

            const translated = this.translate.instant(item.label);

            return !!translated && translated !== item.label;
        });
    }
}
